import jwt_decode from 'jwt-decode';

import { LocalStorageHandler, LocalStorageKeys } from '../../utils/core/local-storage-handler';
import { isDefined } from '../../utils/variables';

interface IntercomSignaturePayload {
  identifier: string;
  name: string;
  email?: string;
}

interface AuthPayload {
  userId: string;
  userEmail: string;
  isOrganizationAdmin: boolean;
  intercomSignature?: IntercomSignaturePayload;
}

// Module-scope token used by the iframe access-token flow, which must not
// persist the authentication token to localStorage. Readers prefer this value
// over the localStorage copy, so the iframe session is isolated to the current
// JS context and dies with it.
let inMemoryToken: string | undefined;

/**
 *  Provides access to the authentication token.
 */
export class TokenService {
  set(token: string) {
    inMemoryToken = undefined;
    LocalStorageHandler.instance.setValue(LocalStorageKeys.Token, token);
  }

  setInMemory(token: string) {
    inMemoryToken = token;
  }

  get(): string {
    if (isDefined(inMemoryToken)) {
      return inMemoryToken;
    }
    return LocalStorageHandler.instance.getValue(LocalStorageKeys.Token)!;
  }

  remove() {
    inMemoryToken = undefined;
    LocalStorageHandler.instance.removeKey(LocalStorageKeys.Token);
  }

  decodeToken(token: string): any {
    return jwt_decode(token);
  }

  getIntercomSignature() {
    const token = this.get();
    if (!isDefined(token)) {
      return undefined;
    }

    return (this.decodeToken(token) as AuthPayload).intercomSignature;
  }
}
